import {Directive} from '@angular/core';

@Directive()
export abstract class AbstractCurrencyDirective {
  protected extractCurrencyIcon(currencyCode: string) {
    if ('EUR' === currencyCode) {
      return 'pi pi-euro';
    }
    return undefined;
  }
}
